import React from 'react';
import clsx from 'clsx';
import {
  PrimaryButton,
  TextLinkButton,
} from 'views/EMR/components/PCC/Walkthrough/components/ContentPrimitives';
import WalkthroughIcon from 'views/EMR/components/PCC/Walkthrough/icons';
import type {
  FooterAction,
  NavigationPageId,
} from 'views/EMR/components/PCC/Walkthrough/types';

type Props = {
  actions: FooterAction[];
  onNavigate: (pageId: NavigationPageId) => void;
  disabled?: boolean;
};

export default function NavigationFooter({
  actions,
  onNavigate,
  disabled = false,
}: Props) {
  const backAction = actions.find((action) => action.variant === 'back');
  const skipAction = actions.find((action) => action.variant === 'skip');
  const nextAction = actions.find((action) => action.variant === 'next');

  return (
    <div className="pcc-walkthrough-footer flex shrink-0 flex-wrap items-center justify-between gap-3 border-t border-[#E2E8F0] bg-white px-4 py-3 sm:px-8 sm:py-0 sm:min-h-20">
      {backAction ? (
        <button
          type="button"
          disabled={disabled}
          onClick={() => onNavigate(backAction.destination)}
          className={clsx(
            'inline-flex h-11 items-center gap-2 text-[15px] font-semibold text-[#475569]',
            'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500',
            disabled ? 'cursor-not-allowed opacity-50' : 'hover:text-[#0F1B2D]',
          )}
        >
          <WalkthroughIcon
            iconKey="arrowLeft"
            className="!h-[18px] !w-[18px]"
          />
          {backAction.label}
        </button>
      ) : (
        <div />
      )}

      {(skipAction || nextAction) ? (
        <div className="ml-auto flex flex-wrap items-center justify-end gap-4 sm:gap-5">
          {skipAction ? (
            <TextLinkButton
              disabled={disabled}
              onClick={() => onNavigate(skipAction.destination)}
            >
              {skipAction.label}
            </TextLinkButton>
          ) : null}
          {nextAction ? (
            <PrimaryButton
              disabled={disabled}
              showArrow
              className="!h-12 !px-6 !text-base !font-semibold"
              onClick={() => onNavigate(nextAction.destination)}
            >
              {nextAction.label}
            </PrimaryButton>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
